/* NUOMA — progressive enhancement; product and cart forms retain native fallbacks. */
document.documentElement.classList.remove('no-js');
(() => {
  let trigger;
  const root = () => window.Shopify?.routes?.root || '/';
  // NUOMA 3.2 — Ouverture/fermeture en deux temps : le panneau glisse réellement
  // (ouverture comme fermeture) avant d'être masqué, sans saut ni clignotement.
  const DRAWER_MS = 520;
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    clearTimeout(drawer._nuomaTimer);
    drawer._nuomaTimer = setTimeout(() => {
      drawer.classList.remove('is-closing');
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.dispatchEvent(new CustomEvent('nuoma:drawer:closed', {bubbles: true}));
    }, DRAWER_MS);
    if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('no-scroll');
    document.querySelector(`[aria-controls="${drawer.id}"]`)?.setAttribute('aria-expanded', 'false');
    if (trigger?.isConnected) trigger.focus({preventScroll: true});
  }
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    document.querySelectorAll('.drawer.is-open').forEach(other => { if (other !== drawer) closeDrawer(other); });
    if (drawer.classList.contains('is-open')) return;
    trigger = document.activeElement;
    clearTimeout(drawer._nuomaTimer);
    drawer.classList.remove('is-closing');
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    void drawer.offsetWidth; // position de départ appliquée avant l'animation
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('no-scroll');
    document.querySelector(`[aria-controls="${id}"]`)?.setAttribute('aria-expanded', 'true');
    setTimeout(() => drawer.querySelector('.drawer__panel button, .drawer__panel a')?.focus({preventScroll: true}), 60);
    drawer.dispatchEvent(new CustomEvent('nuoma:drawer:open', {bubbles: true}));
  }
  window.NUOMA = window.NUOMA || {};
  window.NUOMA.openDrawer = openDrawer;
  window.NUOMA.closeDrawer = closeDrawer;
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-dropdown[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      // L'URL /cart reste le secours natif si JavaScript n'est pas disponible.
      if (opener.tagName === 'A') event.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      if (opener.dataset.drawerOpen === 'CartDrawer') window.NuomaDrawerCart?.refresh();
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
    if (event.target.closest('.drawer a')) closeDrawer(event.target.closest('.drawer'));
  });
  document.addEventListener('keydown', event => {
    const drawer = document.querySelector('.drawer.is-open');
    if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
    if (!drawer) return;
    if (event.key === 'Escape') closeDrawer(drawer);
    if (event.key === 'Tab') {
      const controls = [...drawer.querySelectorAll('.drawer__panel button,.drawer__panel summary,.drawer__panel a[href],input,select,textarea')].filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  function variantChanged(select, updateUrl = true) {
    const option = select.selectedOptions[0];
    const section = select.closest('[data-product-section]');
    if (!section || !option) return;
    const form = select.form;
    const available = option.dataset.available === 'true';
    const price = section.querySelector('[data-product-price]');
    if (price) price.textContent = option.dataset.price;
    const compare = section.querySelector('[data-product-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (form) {
      const input = form.querySelector('[data-variant-id]');
      if (input) input.value = select.value;
      const button = form.querySelector('[type=submit]');
      if (button) {
        button.disabled = !available;
        const label = button.querySelector('[data-add-label]');
        if (label) label.textContent = available ? label.dataset.available : label.dataset.soldout;
      }
      const message = form.querySelector('[data-product-message]');
      if (message) message.textContent = '';
      // NUOMA · Quantité limitée au stock de la variante choisie (plafond 10).
      const qtySelect = form.querySelector('[data-quantity-select]');
      if (qtySelect) {
        const max = Math.max(1, Math.min(10, parseInt(option.dataset.maxQty, 10) || 10));
        const current = Math.min(Number(qtySelect.value) || 1, max);
        qtySelect.replaceChildren(...Array.from({length: max}, (_, i) => new Option(String(i + 1), String(i + 1))));
        qtySelect.value = String(current);
      }
    }
    const sku = section.querySelector('[data-product-sku]');
    if (sku) {
      sku.textContent = `Réf. ${option.dataset.sku || ''}`;
      sku.hidden = !option.dataset.sku;
    }
    // NUOMA 3.0.3 — Filtre galerie par SKU. La version precedente montrait
    // toutes les finitions si Shopify avait supprime les ALT des photos.
    const gallery = section.querySelector('.product-gallery');
    if (gallery) {
      const items = [...gallery.querySelectorAll('[data-media-id]')];
      const allSkus = [...select.options].map(o => (o.dataset.sku || '').trim()).filter(Boolean);
      const chosenSku = (option.dataset.sku || '').trim();
      const classify = el => {
        const attached = (el.dataset.variantSku || '').trim();
        if (allSkus.includes(attached)) return attached;
        const img = el.querySelector('img');
        const alt = img?.getAttribute('alt') || '';
        const altSku = alt.match(/SKU\s*:\s*([0-9]{7})(?![0-9])/i)?.[1];
        if (allSkus.includes(altSku)) return altSku;
        // Les noms des originaux House Nordic sont 3103001.jpg,
        // 3103001-1.jpg, etc. Shopify conserve normalement ce nom.
        const href = el.querySelector('a[href]')?.getAttribute('href') || img?.getAttribute('src') || '';
        let filename = href.split('?')[0].split('/').pop() || '';
        try { filename = decodeURIComponent(filename); } catch (_) { /* Nom déjà lisible */ }
        const found = allSkus.filter(sku => new RegExp('(^|[^0-9])' + sku + '(?=[^0-9]|$)').test(filename));
        return found.length === 1 ? found[0] : '';
      };
      const tagged = items.map(el => ({el, sku: classify(el)}));
      const matches = tagged.filter(x => x.sku === chosenSku);
      let visible = [];
      if (allSkus.length < 2) {
        visible = items;
      } else if (matches.length) {
        visible = matches.map(x => x.el);
      } else {
        // Pas de SKU identifié : on affiche seulement l'image attribuée
        // à la variante (si existante), jamais toute la galerie mélangée.
        const featured = items.find(el => el.dataset.mediaId === option.dataset.media);
        if (featured) visible = [featured];
        else visible = tagged.filter(x => !x.sku).map(x => x.el).slice(0, 1);
      }
      const chosenSet = new Set(visible);
      items.forEach(el => {
        el.hidden = !chosenSet.has(el);
        el.setAttribute('aria-hidden', el.hidden ? 'true' : 'false');
      });
      const featured = visible.find(el => el.dataset.mediaId === option.dataset.media) || visible[0];
      if (featured) gallery.prepend(featured);
      gallery.dataset.colorPhotos = `${visible.length}`;
      gallery.scrollLeft = 0;
      const hint = section.querySelector('.gallery-hint');
      if (hint) {
        hint.hidden = visible.length <= 1;
        if (visible.length > 1) hint.innerHTML = `${visible.length} photos<span class="gallery-hint__touch"> · glissez pour voir la suite</span><span class="gallery-hint__mouse"> · cliquez pour agrandir</span>`;
      }
    }
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) variantChanged(event.target);
  });
  function initialize(scope = document) { scope.querySelectorAll('[data-variant-select]').forEach(select => variantChanged(select, false)); }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => { document.body.classList.remove('no-scroll'); });
  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'fr', {style: 'currency', currency: currency || 'EUR'}).format(cents / 100);
  }
  function showAdded(item, cart) {
    const drawerCart = window.NuomaDrawerCart;
    if (drawerCart && cart) drawerCart.render(cart, {added: true});
    openDrawer('CartDrawer');
    if (drawerCart && !cart) drawerCart.refresh({added: true});
    if (!drawerCart) window.location.assign(root() + 'cart');
  }
  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
  // NUOMA 3.2 — Ajout au panier : chargement, puis coche animée et bouton qui change
  // de couleur ; le panier s'ouvre seulement une fois la confirmation visible.
  const CONFIRM_MS = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 300 : 1100;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ajax-product-form]');
    if (!form) return;
    event.preventDefault();
    const mainButton = form.querySelector('[type=submit]');
    const clicked = event.submitter && event.submitter.type === 'submit' ? event.submitter : mainButton;
    if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-busy') === 'true') return;
    const buttons = [...new Set([mainButton, clicked])];
    const data = new FormData(form);
    const message = form.querySelector('[data-product-message]');
    if (message) { message.textContent = ''; message.classList.remove('is-error'); }
    buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    const select = form.closest('[data-product-section]')?.querySelector('[data-variant-select]');
    if (select) select.disabled = true;
    let added = false;
    try {
      const response = await fetch(root() + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: data});
      const item = await response.json();
      if (!response.ok) throw new Error(typeof item.description === 'string' ? item.description : 'Cet article ne peut pas être ajouté. Vérifiez la quantité et réessayez.');
      added = true;
      // Un échec de relecture du panier ne doit jamais être présenté comme un échec d'ajout.
      let cart = null;
      try { const r = await fetch(root() + 'cart.js', {cache: 'no-store'}); if (r.ok) cart = await r.json(); } catch (_) { /* L'article est bien ajouté. */ }
      buttons.forEach(b => { b.removeAttribute('aria-busy'); b.classList.add('is-added'); b.setAttribute('aria-label', 'Ajouté au panier'); });
      if (message) message.textContent = 'Article ajouté au panier.';
      if (cart) document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped'); });
      document.dispatchEvent(new CustomEvent('nuoma:cart:added', {detail: {form, button: clicked, cart}}));
      await wait(CONFIRM_MS);
      showAdded(item, cart);
      setTimeout(() => buttons.forEach(b => { b.classList.remove('is-added'); b.removeAttribute('aria-label'); }), 900);
    } catch (error) {
      buttons.forEach(b => b.removeAttribute('aria-busy'));
      const text = error instanceof TypeError ? 'Connexion interrompue. Consultez votre panier avant de réessayer pour éviter un doublon.' : error.message;
      if (!message) { window.NUOMA?.toast?.(text); }
      else {
        message.classList.add('is-error');
        message.textContent = text;
        const link = document.createElement('a'); link.href = root() + 'cart'; link.textContent = ' Voir le panier'; link.className = 'text-link'; message.append(link);
      }
    } finally {
      if (select) select.disabled = false;
      const available = select ? select.selectedOptions[0]?.dataset.available === 'true' : true;
      buttons.forEach(b => { b.removeAttribute('aria-busy'); b.disabled = !available; });
      if (!added) buttons.forEach(b => b.classList.remove('is-added'));
    }
  });
})();
